<template lang="pug">
  .component-selectize-plan
    loading-spinner(v-if="loading")
    selectize(v-if="options", :value="value" :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved",  placeholder="Cost", :allowEmptyOption="allowEmptyOption", :selectedValue="selectedValue")
</template>

<script>
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import BaseSelectize from './BaseSelectize'
  import Selectize from '../../../Selectize'
  import LoadingSpinner from "../../../LoadingSpinner";

  export default {
    name: 'SelectizeCommonCost',
    extends: BaseSelectize,
    components: {LoadingSpinner, Selectize},
    data() {
      return {
        loading: true,
        searchableFields: [
          'id',
          'reason',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.commonCosts.list().all(1, 10000, (data) => {
        this.options = data.items
        this.loading = false
      })
    },
    methods: {
      optionTemplate(item, escape) {
        if (item.id) {
          const amount = this.$priceWithVat(item.amount, item.tax)
          return `<div><div><small>CC${item.id}</small></div><div>${item.reason}</div><div><small>${this.$priceWithcurrency(amount)}</small></div></div>`
        }
        return `<div><div>Select cost</div></div>`
      },
      renderTemplate(item, escape) {
        if (item.id) {
          return `<div>CC${item.id} ${item.reason}</div>`
        }
        return `<div><div>Select cpst</div></div>`
      },
      optionsLoader() {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeCommonCost.vue?2afec516